import BirdEcho from './birdEcho';

window.Echo = new BirdEcho({
    appKey: import.meta.env.VITE_BIRD_REALTIME_APP_KEY,
    region: import.meta.env.VITE_BIRD_REALTIME_REGION ?? 'us1',
    authEndpoint: '/bird/auth',
});
